import {
  ViewMoreButton,
  UpArrow,
  DownArrow
} from './InternalLinkModule.styles';

type OwnProps = {
  isExpanded: boolean;
  toggleExpand: () => void;
};

export default function ExpandButton({ isExpanded, toggleExpand }: OwnProps) {
  return (
    <ViewMoreButton
      onClick={() => toggleExpand()}
      data-analytics-id="SEO Links - View More/Less"
    >
      {isExpanded ? 'VIEW LESS' : 'VIEW MORE'}
      {isExpanded ? <UpArrow /> : <DownArrow />}
    </ViewMoreButton>
  );
}
